import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class CommentJobApply extends Component {
    constructor(props) {
        super(props);
        this.state = {
            current_message: '',
            messages: [],
            file: null,
            fileName: '',
        }
        this.handleInptChange = this.handleInptChange.bind(this);
        this.createMessage = this.createMessage.bind(this);
        this.renderCommentInput = this.renderCommentInput.bind(this);
        this.renderAttachmentInput = this.renderAttachmentInput.bind(this);
        this.imageCommment = this.imageCommment.bind(this);
        this.pdfCommment = this.pdfCommment.bind(this);
        this.attachmentRef = null;
        this.setAttachmentRef = element => {
            this.attachmentRef = element;
        }
        this.addAttachment = this.addAttachment.bind(this);
        this.convertedMaxFileSize = this.convertedMaxFileSize.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.openModal = this.openModal.bind(this);
        this.setPreviewRef = element => {
            this.previewRef = element;
        }
    }

    handleInptChange(event) {
        this.setState({current_message: event.target.value});
    }

    createMessage() {
        if (this.state.fileType) {
            $('#attachmentModal').modal('hide');
        }
        let current_message = this.state.current_message;
        let thread_id = this.props.messages[0].message_thread_id;
        let request = {
            thread_id: thread_id,
            current_message: current_message,
        };
        if (this.state.fileType === 'image') {
            request['image'] = this.state.file
            request['image_name'] = this.state.fileName
        }
        if (this.state.fileType === 'pdf') {
            request['pdf'] = this.state.file
            request['pdf_name'] = this.state.fileName
        }

        if((current_message || this.state.fileType ) && thread_id){
            axios.post('/api/houjin/message_detail/create', request).then(response => {
                if (response.data.success) {
                    let newMessages = this.state.messages;
                    newMessages[response.data.content.id] = response.data.content;
                    this.setState({
                        current_message: '',
                        messages: newMessages
                    });
                }
            });
        }
    }

    scrollToBottom(){
        $('.msg-table-list').animate({scrollTop: $('.msg-table-list')[0].scrollHeight}, 1000);
    }
    componentWillReceiveProps(props) {
        this.setState({ messages : props.messages });
    }
    componentDidMount() {
        this.scrollToBottom();
        this.props.handleOnLoad();
    }
    componentDidUpdate() {
        this.scrollToBottom();
    }
    convertedMaxFileSize(maxFileSize) {
        // byte to MB
        return maxFileSize * 1000000
    }
    breakLine(content) {
        let result = content.split('\n');
        return result.map((item, key) =>  {
            if (key != result.length - 1) {
                return <span key={key}>{item}<br/></span>
            }
            return <span key={key}>{item}</span>
        });
    }
    imageCommment(message) {
        return (
            <span>
                <a target="_blank" href={message.image_url}>
                    <img class="mw-100" src={message.image_url}></img>
                </a>
            </span>
        );
    }

    pdfCommment(message) {
        return (
            <span>
                <a target="_blank" href={message.pdf_url}>
                    <i className="material-icons md-48 mx-auto d-block mb-3 text-center">picture_as_pdf</i>
                    {message.pdf_file_name}
                </a>
            </span>
        );
    }

    renderClientMessage(message, i){
        return (
            <li key={i} className="msg-box msg-box-left" id={'msg-box-'+message.id}>
                <div className="msg-avatar">
                    <img src={message.client.avatar_img_file} className="msg-avatar-img" />
                </div>
                <div className="msg-group">
                    <p className="msg-nickname">{message.client.nickname}</p>
                    <div className="msg-content">
                        <span className="msg-icon-arrow"></span>
                        {message.image_file_name ? this.imageCommment(message) : ""}
                        {message.pdf_file_name ? this.pdfCommment(message): ""}
                        {message.message_content ? this.breakLine(message.message_content) : ""}
                        <p className="msg-time">{message.created_at_ago}</p>
                    </div>
                </div>
            </li>
        )
    }

    renderStaffMessage(message, i){
        return (
            <li key={i} className="msg-box msg-box-left" id={'msg-box-'+message.id}>
                <div className="msg-avatar">
                    <img src={message.staff.avatar_img_file} className="msg-avatar-img" />
                </div>
                <div className="msg-group">
                    <p className="msg-nickname">{message.staff.nickname}</p>
                    <div className="msg-content">
                        <span className="msg-icon-arrow"></span>
                        {message.image_file_name ? this.imageCommment(message) : ""}
                        {message.pdf_file_name ? this.pdfCommment(message): ""}
                        {message.message_content ? this.breakLine(message.message_content) : ""}
                        <p className="msg-time">{message.created_at_ago}</p>
                    </div>
                </div>
            </li>
        )
    }

    renderSystemMessage(message, i){
        return (
            <li key={i} className="msg-box msg-box-left" id={'msg-box-'+message.id}>
                <div className="msg-avatar">
                    <img src="/img/sharejob_round_icon.png" className="msg-avatar-img" />
                </div>
                <div className="msg-group">
                    <p className="msg-nickname">自動返信</p>
                    <div className="msg-content">
                        <span className="msg-icon-arrow"></span>
                        {message.message_content ? this.breakLine(message.message_content) : ""}
                        <p className="msg-time">{message.created_at_ago}</p>
                    </div>
                </div>
            </li>
        )
    }

    renderCommentInput(){
        //disable comment if JOB APPLY is canceled (9) or JOB is completed (5) or canceled (9)
        if(this.props.jobApply.status == 2 || this.props.jobApply.status == 9 || (this.props.jobApply.job && (this.props.jobApply.job.status == 5 || this.props.jobApply.job.status == 9)) || this.props.jobApply.deleted_at || (this.props.jobApply.evaluation_staff && this.props.jobApply.evaluation_client)){
            return (
                <textarea value='' className="col-sm-9 col-8 msg-input msg-input-textarea border border-secondary" aria-invalid="false" id="message_content" name="message_content" placeholder="コメントはできません" type="text" disabled style={{backgroundColor: '#fff'}}></textarea>
            )
        } else {
            return (
                <textarea value={this.state.current_message} onChange={this.handleInptChange} className="col-sm-9 col-8 msg-input msg-input-textarea border border-secondary" aria-invalid="false" id="message_content" name="message_content" placeholder="コメントする" type="text" style={{backgroundColor: '#fff'}}></textarea>
            )
        }
    }
    addAttachment(e) {
        this.attachmentRef.click()
    }
    renderAttachmentInput(){
        //disable comment if JOB APPLY is canceled (9) or JOB is completed (5) or canceled (9)
        if(this.props.jobApply.status == 9 || (this.props.jobApply.job && (this.props.jobApply.job.status == 5 || this.props.jobApply.job.status == 9))){
            return (
                <div className="col-sm-1 col-1 p-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30"
                        fill="currentColor" className="bi bi-image-fill" viewBox="0 0 16 16">
                        <path
                            d="M.002 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-12a2 2 0 0 1-2-2V3zm1 9v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12zm5-6.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z" />
                    </svg>
                </div>
            )
        } else {
            return (
                <a href="javascript:void(0);">
                    <div className="col-sm-1 col-1 p-0">
                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30"
                            fill="currentColor" className="bi bi-image-fill" viewBox="0 0 16 16" onClick={(e) => this.addAttachment(e)}>
                            <path
                                d="M.002 3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-12a2 2 0 0 1-2-2V3zm1 9v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12zm5-6.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z" />
                        </svg>
                    </div>
                    <input type="file" name="attachment" value="" accept=".jpg,.jpeg,.gif,.png,.bmp,.pdf" onChange={this.handleChange} style={{ display: "none"}} ref={this.setAttachmentRef}/>
                    <button data-toggle="modal" data-target="#attachmentModal" style={{'display':'none'}} ref={this.setPreviewRef}><span className="size-inherit">プレビュー</span></button>
                </a>
            )
        }
    }
    handleChange(e) {
        e.preventDefault()
        console.log('changeFile')
        let file = e.target.files[0]
        let fileRdr = new FileReader()
        if (file.size > 30000000) {
            console.log(`30MBまでのファイルを選択してください`)
            alert(`30MBまでのファイルを選択してください`)
            e.target.value = '';
            return;
        }
        if (file.type.match('.jpg|.jpeg|.gif|.png|.bmp|.pdf')) {
            // console.log('changeFile:accepted')
            fileRdr.onload = async function (event) {
                // console.log('changeFile:file read')
                this.setState({
                    file: event.target.result,
                    fileName: file.name
                });
                this.openModal(file.type)
            }.bind(this)
            fileRdr.readAsDataURL(file)
        } else {
            //指定以外のファイルでエラー
            console.log(`画像またはPDFを選択してください`)
            alert(`画像またはPDFを選択してください`)
            e.target.value = '';
            return;
        }
    }
    openModal(fileType) {
        switch (true) {
            case /image\/.*/.test(fileType):
                this.setState({
                    'fileType': 'image'
                });
                break;
            case /application\/pdf/.test(fileType):
                this.setState({
                    'fileType': 'pdf'
                });
                break;
            default:
                break;
        }
        this.previewRef.click();
    }
    render() {
        return (
            <React.Fragment>
                <div className="msg-wrap">
                    <div className="msg-table-list">
                        <ul>
                            {this.state.messages.map((message, i) => {
                                if (message.message_kind == 3) {
                                    return this.renderSystemMessage(message, i)
                                } else {
                                    if (message.message_flg == 1) {
                                        return this.renderClientMessage(message, i)
                                    }
                                    if (message.message_flg == 2) {
                                        return this.renderStaffMessage(message, i)
                                    }
                                }
                            })}
                        </ul>
                    </div>
                    <div className="row w-100 justify-content-between align-items-center ml-0 msg-sendbox">
                        {this.renderAttachmentInput()}
                        {this.renderCommentInput()}
                        <div className="col-sm-1 col-2 p-0 mr-2">
                        {/* <div className="col-sm-1 msg-button"> */}
                            <button onClick={this.createMessage} className="btn bg-info text-white btn-radius btn-lg pt-2 pb-2 pr-4 pl-4" type="submit" disabled={this.state.current_message ? false : true}><span className="size-inherit h5">送信</span></button>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="attachmentModal" tabIndex="-1" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content cover-loading-parent">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">ワーカーへのファイル送信</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="form-group row">
                                    <div className="col-sm-12 text-center">
                                    {this.state.fileType == 'image' ?
                                        (<img src={this.state.file} className="col-sm-12"></img>) :
                                        (<>
                                            <i className="material-icons md-48 mx-auto d-block mb-3">picture_as_pdf</i>
                                            {this.state.fileName}
                                        </>)
                                    }
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer text-center">
                                <button type="button" className="btn btn-secondary clearfix" data-dismiss="modal">キャンセル</button>
                                <button type="button" className="btn btn-primary" onClick={this.createMessage} disabled={this.state.file ? '' : 'disabled'}>送信</button>
                            </div>
                            <div className="cover-loading block-hidden">処理中...</div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
